import * as React from 'react';
import * as debounce from 'lodash.debounce';
import './MyTopProducts.scss';
import topProductsServiceInstance from '../../services/products/TopProductsService';
// import ProductCatalog from 'src/components/ProductCatalog';
import ProductModel from 'src/model/product.model';
import listService from 'src/services/lists/ListsService';
import { ifLoggedIn, goToPartDetail, goToHome } from 'src/utils/navigation';
import ProductCard from '../ProductCard/ProductCard';
import Paginator from 'src/components/common/Paginator';
import Breadcrumbs from '../common/Breadcrumbs';
import i18n from 'src/translation/i18n';
import backArrow from '../../assets/back-arrow';
import { analyticsListNames } from 'src/analytics/constant';

interface IMyProductsProps {
  paginator: any;
  handlePageChange(event: any): any;
  isLoggedIn?: boolean;
  fireProductImpressionEvent(data: any): void;
  fireProductClickEvent(data: any): void;
}

interface IMyProductsState {
  isLoading: boolean;
  isFavoriteLoading: boolean;
  selectedFavoriteItem: string;
  products: ProductModel[];
  activePage: number;
}

class MyProducts extends React.Component<IMyProductsProps, IMyProductsState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: true,
      isFavoriteLoading: true,
      selectedFavoriteItem: '',
      products: [],
      activePage: 1
    };
  }

  public handleBuyNow = (productId: string) => {
    const productClicked = this.state.products.find(
      product =>
        `${product.manufacturerCode}  ${product.productNumber}` === productId
    );
    productClicked['position'] =
      this.state.products.indexOf(productClicked) + 1;
    this.props.fireProductClickEvent({
      product: productClicked,
      list: analyticsListNames.PRODUCTS_ON_SALE_VIEW_ALL
    });
    ifLoggedIn(() => goToPartDetail(productId));
  };

  private getProducts = async () => {
    await topProductsServiceInstance.getTopProducts().then(res => {
      this.setState({
        isLoading: false,
        isFavoriteLoading: false,
        selectedFavoriteItem:'',
        products: res
      });
      this.fireProductImpressionAnalytics();
    });
  };

  private handleToggleFavorite = (
    name: string,
    category: string,
    mfc: string,
    favorite: boolean,
    favoriteId: number
  ) => {
    if (favorite) {
      this.setState({ isFavoriteLoading: true,selectedFavoriteItem: name }); // Start loading
      listService.deleteItem(favoriteId).then(res =>this.getProducts());
    } else {
      if(category?.trim() === "WSER") {
        goToPartDetail(`${mfc}  ${name}`);
        return;
      }
      this.setState({ isFavoriteLoading: true,selectedFavoriteItem: name }); 
      listService
        .addItem('favorites', name, mfc)
        .then(res => this.getProducts())
        .catch(error => {
        console.error("Failed to add item:", error);
        this.setState({ isFavoriteLoading: false }); // End loading in case of error
      });;
    }
  };

  private reloadList = () => {
    this.getProducts();
  };

  private handleOnPageChange = (pageNumber: number) => {
    this.setState({ activePage: pageNumber });
  };

  public componentDidMount() {
    this.getProducts();
  }

  private fireProductImpressionAnalytics = () => {
    let productsList: any[];
    if (this.props.isLoggedIn) {
      productsList = this.state.products.filter(
        product => product.discountInfo !== null
      );
    } else {
      productsList = this.state.products;
    }
    this.props.fireProductImpressionEvent({
      products: productsList,
      list: analyticsListNames.PRODUCTS_ON_SALE_VIEW_ALL
    });
  };

  public render() {
    let productsList: any[];
    // if (this.props.isLoggedIn) {
    //   productsList = this.state.products.filter(
    //     product => product.discountInfo !== null
    //   );
    // } else {
    //   productsList = this.state.products;
    // }
    productsList = this.state.products;
    return (
      <div>
        <div className="rp-view-all-list-container">
          <img
            className="rp-back-arrow-view-all"
            src={backArrow}
            alt="RP-Back-To-Page"
            onClick={goToHome}
          />
          <Breadcrumbs>
            {i18n.t('common.home')} / {i18n.t('common.productsOnSale')}
          </Breadcrumbs>
        </div>
        <div className="row no-gutters rp-top-products-section">
          {productsList.length > 0 &&
            productsList.map((product, index) => (
              <ProductCard
                key={index}
                part={product}
                id={product.productNumber}
                name={product.productNumber}
                category={product.category}
                mfc={product.manufacturerCode}
                description={product.description}
                price={product.partnerPrice}
                msrp={product.retailPrice}
                image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                handleOnClicBuyNow={this.handleBuyNow}
                handleToggleFavorite={this.handleToggleFavorite}
                inStock={product.inStock}
                isFavoriteLoading = {this.state.isFavoriteLoading}
                selectedFavoriteItem = {this.state.selectedFavoriteItem} 
                favorite={product.favorite}
                favoriteId={product.idFavoriteItem}
                // deal={!!product.discountInfo}
                deal={true}
                state={product.state}
                stateDescription={product.stateDescription}
                reloadPart={this.reloadList}
                // paginator={this.props.paginator}
              />
            ))}
        </div>
        {/* <div className="row no-gutters rp-top-products-pagination">
          {this.state.products.length >= 10 ? (
            <Paginator
              activePage={this.state.activePage}
              totalPages={Math.round(this.state.products.length / 10)}
              totalItems={this.state.products.length}
              itemsPerPage={10}
              onPageChanged={this.handleOnPageChange}
            />
          ) : (
            <span />
          )}
        </div> */}
      </div>
    );
  }
}
export default MyProducts;
